import { API_BASE_URL } from "./apiClient";

async function partnerFetch(path, options = {}) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(body.message || "Request failed");
  }
  return body;
}

export function partnerLogin(email, password) {
  return partnerFetch("/api/partner/auth/login", {
    method: "POST",
    body: JSON.stringify({ email, password }),
  });
}

export function partnerRegister(payload) {
  return partnerFetch("/api/partner/auth/register", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function partnerLogout() {
  return partnerFetch("/api/partner/auth/logout", { method: "POST" });
}

export function getPartnerMe() {
  return partnerFetch("/api/partner/auth/me");
}

export function requestPartnerPasswordReset(email) {
  return partnerFetch("/api/partner/auth/request-password-reset", {
    method: "POST",
    body: JSON.stringify({ email }),
  });
}

export function resetPartnerPassword(token, password) {
  return partnerFetch("/api/partner/auth/reset-password", {
    method: "POST",
    body: JSON.stringify({ token, password }),
  });
}
